import { notificationSessionCookies } from '../consts/cookie-consts';
import { deleteCookie } from './cookies';

/**
 * Drop the citizen's verified notification session.
 *
 * Called on logout. Signing out has to take the notification session with it:
 * it survived otherwise, so the next person to use the browser was told which
 * phone number the last one had verified. Lives in utils rather than the
 * notifications feature so the app-level logout can reach it without importing
 * a route module.
 */
export const clearNotificationSession = () => {
  notificationSessionCookies.forEach(deleteCookie);
};
